routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.home', {
      url: __env.routes.home,
      template: `<home sh-ctrl="shCtrl"></home>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/home/home.config.js